import FloatingVue, { vTooltip, Dropdown, Tooltip, Menu } from 'floating-vue'
import { createApp } from 'vue'
import { crashPlugin } from '@madxnl/dodo-ui'
import { VueMasonryPlugin } from 'vue-masonry'
import { createPinia } from 'pinia'
import { hotJarPlugin } from './hotjar'
import { router } from './router'
import { sentryPlugin } from './sentry'
import { extensionPlugin } from './extension'
import App from './app/App.vue'
import '@vuepic/vue-datepicker/dist/main.css'
import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import '@vue-flow/controls/dist/style.css'
import 'vue-d3-network-graph/dist/style.css'
import 'floating-vue/style.css'
import './style.css'
import '@madxnl/dodo-ui/dist/style.css'
import './variables.css'
import { askGrok, attentionGrabbing, col, constantAttention, download, yFade } from './directive'
import { SSE } from './sse.js'
function isDashboard() {
  return window.location.href.includes('socialdatabase.com')
}
isDashboard() ? document.body.classList.add('h-full') : undefined

import { i18n } from './i18n.js'
import { i18n as i18nProTargeting } from './pro-targeting/composables/userLanguage'

// @ts-ignore according to docs, SSE is a drop-in replacement for EventSource
EventSource = SSE

const pinia = createPinia()
const app = createApp(App)

app.directive('y-fade', yFade)

app.directive('col', col)

app.directive('attention-grabbing', attentionGrabbing)
app.directive('constant-attention', constantAttention)

app.directive('download', download)

app.directive('ask-grok', askGrok)

FloatingVue.options.themes.tooltip.html = true
app.directive('tooltip', vTooltip)

app.use(router)
app.use(sentryPlugin)
app.use(extensionPlugin)
app.use(hotJarPlugin)
app.use(VueMasonryPlugin)
isDashboard() ? app.use(i18n) : app.use(i18nProTargeting)
app.use(pinia)

app.component('BaseFloat', Dropdown)
app.component('BaseTooltip', Tooltip)
app.component('BaseMenu', Menu)

app.use(crashPlugin({ router }))

app.mount('#app')
